import React from "react";
import { ErrorMessage, Field, useField } from "formik";
import { FormGroup, Label } from "reactstrap";

type CustomRadioButtonProps = {
  name: string;
  as?: string;
  errorComponent?: React.ComponentType<any> | string;
  fieldClassName: string;
  radioBtnTitle: string;
  value?: string;
  formGroupClassName?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
const CustomRadioButton = ({
  as,
  name,
  fieldClassName,
  radioBtnTitle,
  value,
  onChange,
  formGroupClassName,
}: CustomRadioButtonProps) => {
  const [field] = useField(name);
  const id = `${name}_${value}`; // unique id for each radio button

  return (
    <FormGroup className={`pointer ${formGroupClassName}`}>
      <Field
        id={id} // assign unique id
        type={as}
        name={name}
        value={value}
        // checked={field.value === value}
        className={fieldClassName}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          field.onChange(e);
          if (onChange) onChange(e); // trigger parent logic
        }}
      />
      <Label htmlFor={id} className="ms-2 mb-0 pointer">
        {radioBtnTitle}
      </Label>
    </FormGroup>
  );
};

export default CustomRadioButton;
